import ProgramAdd from "./program/ProgramAdd";
import ProgramEdit from "./program/ProgramEdit";
import ProgramList from "./program/ProgramList";
import QuizAdd from "./quiz/QuizAdd";
import QuizEdit from "./quiz/QuizEdit";
import QuizList from "./quiz/QuizList";
import QuizQuestionview from "./quiz/QuizQuestionview";
import AddService from "./services/AddService";
// import ServiceList from "./services/AddService";
import EditService from "./services/EditService";
import ServiceList from "./services/ServiceList";
import Add from "./Add";
import List from "./List";
import UserMangement from "./user-management/UserMangement";
//rutik

import EditHomeBanner from "./banner/EditHomeBanner";
import HomeBanner from "./banner/AddHomeBanner";
import AddTestimonial from "./testimonial/AddTestimonial";
import EditTestimonial from "./testimonial/EditTestimonial";
import TestimonialList from "./testimonial/TestimonialList";

import HomerBannerList from "./banner/HomerBannerList";
import Showtask from "./Newpages/Showtask";
import AddTask from "./Newpages/AddTask";
import AssignNewTask from "./task/AssignNewTask";
import AddProject from "./projects/AddProject";
import ProjectList from "./projects/ProjectList";
import EditProject from "./projects/EditPRoject";
import College_list from "./college-school/College_list";
import ClgStudentList from "./college-school/ClgStudentList";
import MentorRequestList from "./request/MentorRequestList";
import SchoolCollegeRequestList from "./request/SchoolCollegeRequestList";
import StudentRegisterList from "./register-student/StudentRegisterList";
import AddStudent from "../college/AddStudent";

import AssessmentQuestion from "../student/assessmenttest/AssessmentQuestion";
import AssessmentTestStu from "../student/assessmenttest/AssessmentTestStu";
import AssessmentTestResult from "../student/assessmenttest/AssessmentTestResult";
import ReAssessmentTest from "../student/assessmenttest/ReAssessmentTest";
import { uiRoutes } from "../../../routes/ui/uiRoutes";

import Addsyallbus from "./roboticsyallbus/Addsyallbus";
import Listsyallbus from "./roboticsyallbus/Listsyallbus";
import Editsyallbus from "./roboticsyallbus/Editsyallbus";

import ModulesAdd from "./modules/ModulesAdd";
import ModulesList from "./modules/ModulesList";
import ModulesEdit from "./modules/ModulesEdit";

import CreateRoadMap from "./roadmap/CreateRoadMap";
import ListRoadMap from "./roadmap/ListRoadMap";
import UpdateRoadMap from "./roadmap/UpdateRoadMap";
import AddAssessments from "../mentor/assessments/AddAssesments";
import AssessmentsList from "../mentor/assessments/AssessmentsList";
import MentorStudentList from "../mentor/student/MentorStudentList";
import MentorStudentGroupList from "../mentor/groups/MentorStudentGroupList";
import MentorAddGroup from "../mentor/groups/MentorAddGroup";
import StudentDailyTask from "../student/dailytask/StudentDailyTask";
import Chatbot from "../mentor/chatbot/Chatbot";
import AssignTask from "../mentor/assign task/AssignTask";
import MentorAssignNewTask from "../mentor/assign task/MentorAssignNewTask";
import Schedule from "../mentor/Session/Schedule";
import NewSession from "../mentor/Session/NewSession";
import Home from "../mentor/Home/Home";
import TaskList from "../mentor/CreateTask/TaskList";
import TaskAdd from "../mentor/CreateTask/TaskAdd";
import Mentor from "../student/mentors/Mentor";
import Resource from "../student/resources/Resource";
import SessionList from "../student/sessions/SessionList";
import StudentChatbot from "../student/studentchatbot/StudentChatbot";
import Progress from "../student/progress/Progress";
import RoadMap from "../student/home/RoadMap";
import StudentProfile from "../student/profile/StudentProfile";
import MentorStudentListProfile from "../mentor/student/MentorStudentListProfile";
import AdminStudentAdd from "./add student/AdminStudentAdd";
import AdminStudentList from "./add student/AdminStudentList";
import AdminMentor from "./mentor/AdminMentor";
import AssignStudentToMentor from "./mentor/AssignStudentToMentor";
import GroupStudentList from "../mentor/groups/GroupStudentList";

import UpdateStudentProfile from "../student/profile/UpdateStudentProfile";
import ProgramServiceAddForm from "./program-service/ProgramServiceAddForm";
import ProgramServiceList from "./program-service/ProgramServiceList";
import ProgramServiceEditForm from "./program-service/ProgramServiceEditForm";
import CampusToCorporate from "../../ui/campus-to-corporate/CampusToCorporate";
import Contactus from "../../ui/contact/Contactus";

import RoboticsKitAdd from "./robotics-kit/RoboticsKitAdd";
import RoboticsKitList from "./robotics-kit/RoboticsKitList";
import RoboticsKitEdit from "./robotics-kit/RoboticsKitEdit";
import RoboticsImageAdd from "./robotics-image/RoboticsImageAdd";
import RoboticsImageList from "./robotics-image/RoboticsImageList";
import RoboticsImageEdit from "./robotics-image/RoboticsImageEdit";
import TaskEdit from "../mentor/CreateTask/TaskEdit";
import MentorStudentTask from "../mentor/student/MentorStudentTask";
import MentorStudentSession from "../mentor/student/MentorStudentSession";
import Attendance from "../student/studenttime/Attendance";
import AttendanceList from "../student/studenttime/AttendanceList";
import ShowAttendance from "./showattendance/ShowAttendance";
import { elements } from "chart.js";
import AddCaseStudy from "./case study/AddCaseStudy";
import ListCaseStudy from "./case study/ListCaseStudy";
import EditCaseStudy from "./case study/EditCaseStudy";
import CaseStudyPage from "../../ui/case-study/CaseStudyPage";
import CaseSectionDetailsPage from "../../ui/case-study/CaseSectionDetailsPage";
import AddBlog from "./blogs/AddBlog";
import BlogList from "./blogs/BlogList";
import EditBlog from "./blogs/EditBlog";
import LatestBlogs from "../../ui/ui blogs/LatestBlogs";
import DetailsBlog from "../../ui/ui blogs/DetailsBlog";
import AddGallery from "./blogs/blog gallery/AddGallery";
import EditGallery from "./blogs/blog gallery/EditGallery";
import ListGallery from "./blogs/blog gallery/ListGallery";
export const adminConfig = [
  { path: "/add", element: <Add /> },
  { path: "/users", element: <List /> },

 { path: uiRoutes.admin.quiz.add, element: <QuizAdd /> },
  { path: uiRoutes.admin.quiz.edit, element: <QuizEdit /> },
  { path: uiRoutes.admin.quiz.list, element: <QuizList /> },
  { path: uiRoutes.admin.quiz.questionlist, element: <QuizQuestionview/> },
  
  { path: uiRoutes.admin.program.add, element: <ProgramAdd /> },
  { path: uiRoutes.admin.program.list, element: <ProgramList /> },
  { path: uiRoutes.admin.program.edit, element: <ProgramEdit /> },

  { path: uiRoutes.admin.services.add, element: <AddService /> },
  { path: uiRoutes.admin.services.list, element: <ServiceList /> },
  { path: uiRoutes.admin.services.edit, element: <EditService /> },

  { path: uiRoutes.admin.roadmap.add, element: <CreateRoadMap /> },
  { path: uiRoutes.admin.roadmap.list, element: <ListRoadMap /> },
  { path: uiRoutes.admin.roadmap.edit, element: <UpdateRoadMap /> },

  { path: "/users-mangement", element: <UserMangement /> },

  { path: uiRoutes.admin.projects.add, element: <AddProject /> },
  { path: uiRoutes.admin.projects.edit, element: <EditProject /> },
  { path: uiRoutes.admin.projects.list, element: <ProjectList /> },

  { path: "add-testimonial", element: <AddTestimonial /> },
  { path: "edit-testimonial", element: <EditTestimonial /> },
  { path: "testimonial-list", element: <TestimonialList /> },

  { path: uiRoutes.admin.homeBanner.add, element: <HomeBanner /> },
  { path: uiRoutes.admin.homeBanner.edit, element: <EditHomeBanner /> },
  { path: uiRoutes.admin.homeBanner.list, element: <HomerBannerList /> },

  { path: uiRoutes.admin.roboticSyllabus.add, element: <Addsyallbus /> },
  { path: uiRoutes.admin.roboticSyllabus.list, element: <Listsyallbus /> },
  { path: uiRoutes.admin.roboticSyllabus.edit, element: <Editsyallbus /> },

  { path: uiRoutes.admin.testimonial.add, element: <AddTestimonial /> },
  { path: uiRoutes.admin.testimonial.edit, element: <EditTestimonial /> },
  { path: uiRoutes.admin.testimonial.list, element: <TestimonialList /> },

  { path: uiRoutes.admin.modules.add, element: <ModulesAdd /> },
  { path: uiRoutes.admin.modules.list, element: <ModulesList /> },
  { path: uiRoutes.admin.modules.edit, element: <ModulesEdit /> },

  { path: "show-task", element: <Showtask /> },
  { path: "add-task", element: <AddTask /> },
  { path: "assign-task", element: <AssignNewTask /> },
  { path: "/college-list", element: <College_list /> },
  { path: "/student-list", element: <ClgStudentList /> },
  { path: "/college-register-list", element: <SchoolCollegeRequestList /> },
  { path: "/mentor-register-list", element: <MentorRequestList /> },
  { path: "/student-register-list", element: <StudentRegisterList /> },
  { path: "/add-student", element: <AddStudent /> },
  // { path: "/add-assessments", element: <AddAssesments /> },
  // { path: "/assessments-list", element: <AssessmentsList /> },
         { path: uiRoutes.admin.student.add, element: <AdminStudentAdd/> },
         { path: uiRoutes.admin.student.list, element: <AdminStudentList/> },

         {path:uiRoutes.admin.mentor.list,element:<AdminMentor/>},
{path:uiRoutes.admin.mentor.add,element:<AssignStudentToMentor/>},

 {path:uiRoutes.admin.programservice.add,element: <ProgramServiceAddForm/>},
  {path:uiRoutes.admin.programservice.list,element: <ProgramServiceList/>},
  {path:uiRoutes.admin.programservice.edit,element: <ProgramServiceEditForm/>},

 {path:uiRoutes.admin.roboticskit.add,element: <RoboticsKitAdd/>},
    {path:uiRoutes.admin.roboticskit.list,element: <RoboticsKitList/>},
    {path:uiRoutes.admin.roboticskit.edit,element: <RoboticsKitEdit/>},
        {path:uiRoutes.admin.roboticsimage.add,element: <RoboticsImageAdd/>},
        {path:uiRoutes.admin.roboticsimage.list,element: <RoboticsImageList/>},
        {path:uiRoutes.admin.roboticsimage.edit,element: <RoboticsImageEdit/>},

        {path:uiRoutes.admin.showattendance,element: <ShowAttendance/>},

         // case study
{path:uiRoutes.admin.casestudy.add,element:<AddCaseStudy/>},
{path:uiRoutes.admin.casestudy.list,element:<ListCaseStudy/>},
{path:uiRoutes.admin.casestudy.edit,element:<EditCaseStudy/>},
  // mentor
         // assessments
         { path: uiRoutes.mentor.assessment.add, element: <AddAssessments/> },
         { path: uiRoutes.mentor.assessment.list, element: <AssessmentsList/> },
         //  students
         { path: uiRoutes.mentor.student.list, element: <MentorStudentList/> },
         { path: uiRoutes.mentor.student.profile, element: <MentorStudentListProfile/> },
         { path: uiRoutes.mentor.student.task, element: <MentorStudentTask/> },
         { path: uiRoutes.mentor.student.session, element: <MentorStudentSession/> },



         //groups
         {path:uiRoutes.mentor.groups.list,element:<MentorStudentGroupList/>},
         {path:uiRoutes.mentor.groups.add,element:<MentorAddGroup/>},
         {path:uiRoutes.mentor.groups.viewmember,element:<GroupStudentList/>},

        //chatbot
        {path:uiRoutes.mentor.chatbot.list,element:<Chatbot/>},
        //assign task
        {path:uiRoutes.mentor.AssignTask.list,element:<AssignTask/>},
        {path:uiRoutes.mentor.AssignTask.add,element:<MentorAssignNewTask/>},
        // sessions
        { path: uiRoutes.mentor.sessions.list, element: <Schedule/> },
        { path: uiRoutes.mentor.sessions.add, element: <NewSession/> },
        //home
        { path: uiRoutes.mentor.Home.Home, element: <Home/> },
        //create task
        { path: uiRoutes.mentor.CreateTask.list, element: <TaskList/> },
        { path: uiRoutes.mentor.CreateTask.add, element: <TaskAdd/> },
        { path: uiRoutes.mentor.CreateTask.edit, element: <TaskEdit/> },


     // student side
  //assessment
  { path:uiRoutes.student.assessment.assessmentteststu, element: <AssessmentTestStu /> },
  { path:uiRoutes.student.assessment.assessmenttestresult, element: <AssessmentTestResult /> },
  {path:uiRoutes.student.assessment.assessmentquestion, element: <AssessmentQuestion /> },
  { path:uiRoutes.student.assessment.reassessment, element: <ReAssessmentTest /> },
  //dailytask
  { path:uiRoutes.student.dailytasks.list, element: <StudentDailyTask/> },
  //mentorpage
 {path:uiRoutes.student.studentMentors,element:<Mentor/>},
 //resourcepage
  {path:uiRoutes.student.studentResources,element:<Resource/>},
  //sessionlistpage
  {path:uiRoutes.student.studentSessions,element:<SessionList/>},
  //studentchatbotpagr
  {path:uiRoutes.student.studentChatbot,element:<StudentChatbot/>},
  //progresspage
  {path:uiRoutes.student.studentProgress,element:<Progress/>},
  //home roademap
  {path:uiRoutes.student.studenthome,element:<RoadMap/>},
  // student profile
  { path: uiRoutes.student.studentprofile, element: <StudentProfile /> },
 
  { path: uiRoutes.student.editProfile, element: <UpdateStudentProfile/> },

// Attendance
  {path: uiRoutes.student.attendance.add,element:<Attendance/>},
{path: uiRoutes.student.attendance.list,element:<AttendanceList/>},

///website 
{
    path: uiRoutes.website.Contact,
    element: <Contactus/>,
  },
{
    path: uiRoutes.website.campusToCorporate,
    element: <CampusToCorporate/>,
  },
  {
    path: uiRoutes.website.casestudy,
    element: <CaseStudyPage/>,
  },
   {
    path: uiRoutes.website.casestudydetails,
    element: <CaseSectionDetailsPage/>,
  },
 
{path:uiRoutes.admin.blog.add,element:<AddBlog/>},
  {path:uiRoutes.admin.blog.list,element:<BlogList/>},
  {path:uiRoutes.admin.blog.edit,element:<EditBlog/>},
  //blogs gallery
  {path:uiRoutes.admin.blogsgallery.edit,element:<EditGallery/>},
  {path:uiRoutes.admin.blogsgallery.add,element:<AddGallery/>},
  {path:uiRoutes.admin.blogsgallery.list,element:<ListGallery/>},




  //blog website
  {path:uiRoutes.website.blogs,element:<LatestBlogs/>},
  {path:uiRoutes.website.blogsdetails,element:<DetailsBlog/>},


  // {
  //   path: "/add",
  //   element: <Add />,
  // },
  // {
  //   path: "/users",
  //   element: <List />,
  // },

  // // program
  // {
  //   path: "/add-progarm",
  //   element: <ProgramAdd />,
  // },
  // {
  //   path: "/progarm-list",
  //   element: <ProgramList />,
  // },
  // {
  //   path: "/progarm-edit/:slug",
  //   element: <ProgramEdit />,
  // },

  // //quiz
  // { path: "/quiz-list", element: <QuizList /> },
  // { path: "/add-quiz", element: <QuizAdd /> },
  // { path: "/quiz-edit/:slug", element: <QuizEdit /> },
  // //service
  // { path: "/service-list", element: <ServiceList /> },
  // { path: "/add-service", element: <AddService /> },
  // { path: "/edit-service/:slug", element: <EditService /> },
  // { path: "/users-mangement", element: <UserMangement /> },
  // // rutik
  // {
  //   path: "/add-project",
  //   element: <AddProject />,
  // },
  // {
  //   path: "/project-list",
  //   element: <ProjectList />,
  // },
  // {
  //   path: "/edit-project",
  //   element: <EditProject />,
  // },
  // {
  //   path: "add-testimonial",
  //   element: <AddTestimonial />,
  // },
  // {
  //   path: "edit-testimonial",
  //   element: <EditTestimonial />,
  // },
  // {
  //   path: "testimonial-list",
  //   element: <TestimonialList />,
  // },
  // {
  //   path: "add-homebanner",
  //   element: <HomeBanner />,
  // },
  // {
  //   path: "edit-homebanner",
  //   element: <EditHomeBanner />,
  // },
  // {
  //   path: "homebanner-list",
  //   element: <HomerBannerList />,
  // },
  // {
  //   path: "show-task",
  //   element: <Showtask />,
  // },
  // {
  //   path: "add-task",
  //   element: <AddTask />,
  // },
  // {
  //   path: "assign-task",
  //   element: <AssignNewTask />,
  // },

  // // college /school
  // {
  //   path: "/college-list",
  //   element: <College_list />,
  // },
  // {
  //   path: "/student-list",
  //   element: <ClgStudentList />,
  // },

  // //Request
  // {
  //   path: "/college-register-list",
  //   element: <SchoolCollegeRequestList />,
  // },
  // {
  //   path: "/mentor-register-list",
  //   element: <MentorRequestList />,
  // },
  // // register std-register page

  // {
  //   path: "/student-register-list",
  //   element: <StudentRegisterList />,
  // },
  // //user college add student
  // {
  //   path: "/add-student",
  //   element: <AddStudent />,
  // },

  // //assessments mentor side
  // {
  //   path: "/add-assessments",
  //   element: <AddAssesments />,
  // },
  // {
  //   path: "/assessments-list",
  //   element: <AssessmentsList />,
  // },

  // //assessments student side
  // {
  //   path: "/assessments-test",
  //   element: <AssessmentTestStu />,
  // },
  // {
  //   path: "/assessments-result",
  //   element: <AssessmentTestResult />,
  // },
  // {
  //   path: "/assessments-questions",
  //   element: <AssessmentQuestion />,
  // },
  // {
  //   path: "/assessments-exam",
  //   element: <ReAssessmentTest />,
  // },
];
